import { useEffect, useState } from "react";
import { api, exportPdfUrl } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileDown, Printer } from "lucide-react";

export default function ExportPage() {
  const [rooms, setRooms] = useState([]);
  const [f, setF] = useState({
    date_from: "2024-02-01",
    date_to: new Date().toISOString().slice(0, 10),
    room_id: "",
  });

  useEffect(() => { api.get("/rooms").then((r) => setRooms(r.data)); }, []);

  const download = () => {
    const params = {};
    if (f.date_from) params.date_from = f.date_from;
    if (f.date_to) params.date_to = f.date_to;
    if (f.room_id) params.room_id = f.room_id;
    window.open(exportPdfUrl(params), "_blank");
  };

  return (
    <div>
      <PageHeader title="PDF-Export & Berichte" subtitle="Audit-fertiger Nachweis für die Lebensmittelkontrolle" />

      <div className="rounded-xl border border-slate-200 bg-white p-6 max-w-2xl space-y-5">
        <div className="flex items-center gap-3">
          <img src="/haccp-logo.png" alt="HACCP" className="h-12 w-12 object-contain" />
          <div>
            <div className="font-heading font-bold text-slate-900">Bowlingcenter Eisleben</div>
            <div className="text-xs text-slate-500">Friedensstraße 12, 06295 Eisleben · Tel. 03475748063</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1.5"><Label>Von</Label>
            <Input type="date" data-testid="export-from" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>Bis</Label>
            <Input type="date" data-testid="export-to" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} /></div>
        </div>
        <div className="space-y-1.5"><Label>Bereich</Label>
          <Select value={f.room_id || "all"} onValueChange={(v) => setF({ ...f, room_id: v === "all" ? "" : v })}>
            <SelectTrigger data-testid="export-room"><SelectValue placeholder="Alle Bereiche" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Alle Bereiche</SelectItem>
              {rooms.map((r) => <SelectItem key={r.id} value={r.id}>{r.name}</SelectItem>)}
            </SelectContent>
          </Select></div>

        <Button data-testid="btn-pdf-export" onClick={download} className="w-full">
          <FileDown className="h-4 w-4 mr-2" /> PDF-Bericht erstellen
        </Button>
        <p className="text-xs text-slate-400 text-center">
          Der Bericht enthält Logo, Center-Stammdaten, alle Tätigkeiten mit Temperaturen und Status im gewählten Zeitraum sowie ein Unterschriftsfeld.
        </p>
      </div>
    </div>
  );
}
